import { types, Instance } from 'mobx-state-tree';
// Persistence disabled - feature flags loaded from backend

interface FeatureFlag {
  key: string;
  enabled: boolean;
  description: string;
}

export const FeatureFlagsStore = types
  .model('FeatureFlagsStore', {
    isWorkTabEnabled: types.optional(types.boolean, false),
    isDashboardEnabled: types.optional(types.boolean, false),
    showLayoutLogs: types.optional(types.boolean, false),
    showCreationLogs: types.optional(types.boolean, false),
    showDatabaseLogs: types.optional(types.boolean, false),
    showPresenceLogs: types.optional(types.boolean, true),
    showCursorLogs: types.optional(types.boolean, false),
    // Console-log category flags (default OFF)
    showCommentsLogs: types.optional(types.boolean, false),
    showMindmapLogs: types.optional(types.boolean, false),
    showFlowLogs: types.optional(types.boolean, false),
    showProfileLogs: types.optional(types.boolean, false),
    showNetworkLogs: types.optional(types.boolean, false),
    showUILogs: types.optional(types.boolean, false),
    showGeneralLogs: types.optional(types.boolean, false),
    enableAutoLayout: types.optional(types.boolean, true),
    showCursors: types.optional(types.boolean, true),
    showPlaceholders: types.optional(types.boolean, true)
  })
  .actions((self) => ({
    setWorkTabEnabled(enabled: boolean) {
      self.isWorkTabEnabled = enabled;
      // Persistence is handled automatically by mst-persist
    },
    setDashboardEnabled(enabled: boolean) {
      self.isDashboardEnabled = enabled;
      // Persistence is handled automatically by mst-persist
    },
    toggleFlag(flagName: keyof typeof self) {
      (self as any)[flagName] = !(self as any)[flagName];
    },
    async initializeFromDB() {
      // Feature flags are now stored locally only
      // No need to fetch from database
      console.log('Feature flags initialized from localStorage');
    }
  }));

export interface IFeatureFlagsStore extends Instance<typeof FeatureFlagsStore> {}

// Create the store instance
// REMOVED: No longer creating a singleton instance here. AppStore is responsible.
// const featureFlagsStore = FeatureFlagsStore.create();

// DISABLED persistence to prevent MST reference conflicts
// persist('featureFlags', featureFlagsStore, {
//   storage: localStorage,
//   jsonify: true,
// });

// REMOVED: No longer exporting a singleton instance.
// export { featureFlagsStore };